export const manifest = {
  screens: {
    scr_ryzus6: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_brej6t: { name: "Home (Alternative)", route: "/unlisted/home-alt", position: {"x":1560,"y":220} },
    scr_lx3cz8: { name: "Home (E-commerce ICP)", route: "/unlisted/ecommerce", position: {"x":2960,"y":220} },
    scr_qgxl6h: { name: "Home (Team Workspace)", route: "/unlisted/team-workspace", position: {"x":4360,"y":220} },
    scr_dta5af: { name: "Home (Enterprise Platform)", route: "/enterprise-platform", position: {"x":5760,"y":220} },
    scr_6y6t6n: { name: "Sign up — Landing", route: "/app-screen-mockups/signup", state: {"step":1}, position: {"x":160,"y":2200} },
    scr_3f9xrx: { name: "Google — Choose account", route: "/app-screen-mockups/signup", state: {"step":20}, position: {"x":16960,"y":2200} },
    scr_4oigbm: { name: "Google — Grant access", route: "/app-screen-mockups/signup", state: {"step":21}, position: {"x":18360,"y":2200} },
    scr_c96ohb: { name: "Giga web chat (Google path)", route: "/app-screen-mockups/signup", state: {"step":22}, position: {"x":19760,"y":2200} },
    scr_8jq2yu: { name: "Slack consent", route: "/app-screen-mockups/signup", state: {"step":2}, position: {"x":1560,"y":2200} },
    scr_fylw3v: { name: "Slack permissions", route: "/app-screen-mockups/signup", state: {"step":3}, position: {"x":2960,"y":2200} },
    scr_ivnco7: { name: "Choose channels", route: "/app-screen-mockups/signup", state: {"step":4}, position: {"x":4360,"y":2200} },
    scr_ah2wo2: { name: "About you", route: "/app-screen-mockups/signup", state: {"step":5}, position: {"x":5760,"y":2200} },
    scr_omt78o: { name: "Tool picker", route: "/app-screen-mockups/signup", state: {"step":6}, position: {"x":7160,"y":2200} },
    scr_9gr5ba: { name: "Connections", route: "/app-screen-mockups/signup", state: {"step":7}, position: {"x":8560,"y":2200} },
    scr_injbnc: { name: "Now go to Slack", route: "/app-screen-mockups/signup", state: {"step":8}, position: {"x":9960,"y":2200} },
    scr_sfdb81: { name: "Slack — Giga DM", route: "/app-screen-mockups/signup", state: {"step":9}, position: {"x":11360,"y":2200} },
    scr_8f0skm: { name: "Welcome back", route: "/app-screen-mockups/signup", state: {"step":10}, position: {"x":12760,"y":2200} },
    scr_yvq2cz: { name: "Start your trial", route: "/app-screen-mockups/signup", state: {"step":11}, position: {"x":14160,"y":2200} },
    scr_0roaqn: { name: "Slack workspace already connected", route: "/app-screen-mockups/slack-oauth-callback", position: {"x":15560,"y":2200} },
    scr_51jglr: { name: "Sign in — Welcome back", route: "/app-screen-mockups/sign-in", position: {"x":160,"y":22000} },
    scr_qsqbrh: { name: "Trial — Create account", route: "/app-screen-mockups/trial", state: {"step":"account"}, position: {"x":160,"y":20020} },
    scr_c83mze: { name: "Trial — Checkout", route: "/app-screen-mockups/trial", state: {"step":"checkout"}, position: {"x":1560,"y":20020} },
    scr_w8rlgg: { name: "Trial — Bank authorization", route: "/app-screen-mockups/trial", state: {"step":"checkout","showAuth":true}, position: {"x":2960,"y":20020} },
    scr_8qdbke: { name: "Trial — Welcome", route: "/app-screen-mockups/trial", state: {"step":"welcome"}, position: {"x":4360,"y":20020} },
    scr_mxxj8o: { name: "Client Management", route: "/unlisted/use-cases/client-management", position: {"x":160,"y":4180} },
    scr_xhpoc8: { name: "Growth & Marketing", route: "/unlisted/use-cases/growth-marketing", position: {"x":1560,"y":4180} },
    scr_e1i5ji: { name: "Founders & Execs", route: "/unlisted/use-cases/founders-execs", position: {"x":2960,"y":4180} },
    scr_2i9k3d: { name: "Pricing", route: "/pricing", position: {"x":160,"y":6160} },
    scr_mhpjmw: { name: "Bespoke", route: "/unlisted/bespoke", position: {"x":160,"y":14080} },
    scr_uconpq: { name: "Blog", route: "/unlisted/blog", position: {"x":2960,"y":8140} },
    scr_sl86jc: { name: "Research", route: "/unlisted/research", position: {"x":1560,"y":8140} },
    scr_cb21wf: { name: "Case Studies", route: "/unlisted/case-studies", position: {"x":160,"y":8140} },
    scr_xd5o9w: { name: "Changelog", route: "/unlisted/changelog", position: {"x":4360,"y":8140} },
    scr_pd9uqn: { name: "Security", route: "/unlisted/security", position: {"x":5760,"y":8140} },
    scr_jgq2zv: { name: "Compare — ChatGPT", route: "/unlisted/compare/chatgpt", position: {"x":160,"y":10120} },
    scr_eldpu2: { name: "Watch Giga work", route: "/demo", position: {"x":160,"y":12100} },
    scr_b6vq1n: { name: "Book a demo", route: "/demo/book", position: {"x":1560,"y":12100} },
    scr_zhfffe: { name: "Architecture Home", route: "/unlisted/architecture", position: {"x":7160,"y":8140} },
    scr_8djzwg: { name: "All Integrations", route: "/integrations", position: {"x":8560,"y":8140} },
    scr_jby7lc: { name: "Consulting", route: "/unlisted/consulting", position: {"x":160,"y":16060} },
    scr_f9mdlt: { name: "Creator Program", route: "/creator-program", position: {"x":160,"y":18040} },
    scr_viktor1: { name: "Viktor Alternatives", route: "/viktor-alternative", position: {"x":1560,"y":10120} },
    scr_oabucw: { name: "Track chat", route: "/app-screen-mockups/signup", state: {"step":22,"chatView":"tracks","chatTrack":"Close CRM setup & Sales pipeline","trackSection":"chat"}, position: {"x":160,"y":23980} },
    scr_r395xl: { name: "Track overview", route: "/app-screen-mockups/signup", state: {"step":22,"chatView":"tracks","chatTrack":"Close CRM setup & Sales pipeline","trackSection":"overview"}, position: {"x":1560,"y":23980} },
    scr_o13rzo: { name: "Track resources", route: "/app-screen-mockups/signup", state: {"step":22,"chatView":"tracks","chatTrack":"Close CRM setup & Sales pipeline","trackSection":"linked"}, position: {"x":2960,"y":23980} },
    scr_ql2qkx: { name: "Track activity", route: "/app-screen-mockups/signup", state: {"step":22,"chatView":"tracks","chatTrack":"Close CRM setup & Sales pipeline","trackSection":"activity"}, position: {"x":4360,"y":23980} },
  },
  sections: {
    sec_16437l: { name: "Home", x: 0, y: 0, width: 7120, height: 1180 },
    sec_q5m936: { name: "Sign up flow", x: 0, y: 1980, width: 21120, height: 1180 },
    sec_a5hi1s: { name: "Use Cases", x: 0, y: 3960, width: 4320, height: 1180 },
    sec_16dxlv: { name: "Pricing", x: 0, y: 5940, width: 1520, height: 1180 },
    sec_4fhzmy: { name: "Content & Resources", x: 0, y: 7920, width: 9920, height: 1180 },
    sec_ragkln: { name: "Comparisons", x: 0, y: 9900, width: 1520, height: 1180 },
    sec_9lgnx9: { name: "Product Demo", x: 0, y: 11880, width: 2920, height: 1180 },
    sec_lolr7p: { name: "Bespoke", x: 0, y: 13860, width: 1520, height: 1180 },
    sec_9e3vw3: { name: "Consulting", x: 0, y: 15840, width: 1520, height: 1180 },
    sec_9jtu3w: { name: "Creator Program", x: 0, y: 17820, width: 1520, height: 1180 },
    sec_o8b4eg: { name: "Trial flow", x: 0, y: 19800, width: 5720, height: 1180 },
    sec_qxv0p6: { name: "Sign in flow", x: 0, y: 21780, width: 1520, height: 1180 },
    sec_qndaa4: { name: "Workspace Dashboard", x: 0, y: 23760, width: 5720, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_16437l", children: [
      { kind: "screen", id: "scr_ryzus6" },
      { kind: "screen", id: "scr_brej6t" },
      { kind: "screen", id: "scr_lx3cz8" },
      { kind: "screen", id: "scr_qgxl6h" },
      { kind: "screen", id: "scr_dta5af" },
    ] },
    { kind: "section", id: "sec_q5m936", children: [
      { kind: "screen", id: "scr_6y6t6n" },
      { kind: "screen", id: "scr_8jq2yu" },
      { kind: "screen", id: "scr_fylw3v" },
      { kind: "screen", id: "scr_ivnco7" },
      { kind: "screen", id: "scr_ah2wo2" },
      { kind: "screen", id: "scr_omt78o" },
      { kind: "screen", id: "scr_9gr5ba" },
      { kind: "screen", id: "scr_injbnc" },
      { kind: "screen", id: "scr_sfdb81" },
      { kind: "screen", id: "scr_8f0skm" },
      { kind: "screen", id: "scr_yvq2cz" },
      { kind: "screen", id: "scr_0roaqn" },
      { kind: "screen", id: "scr_3f9xrx" },
      { kind: "screen", id: "scr_4oigbm" },
      { kind: "screen", id: "scr_c96ohb" },
    ] },
    { kind: "section", id: "sec_a5hi1s", children: [
      { kind: "screen", id: "scr_mxxj8o" },
      { kind: "screen", id: "scr_xhpoc8" },
      { kind: "screen", id: "scr_e1i5ji" },
    ] },
    { kind: "section", id: "sec_16dxlv", children: [
      { kind: "screen", id: "scr_2i9k3d" },
    ] },
    { kind: "section", id: "sec_4fhzmy", children: [
      { kind: "screen", id: "scr_cb21wf" },
      { kind: "screen", id: "scr_sl86jc" },
      { kind: "screen", id: "scr_uconpq" },
      { kind: "screen", id: "scr_xd5o9w" },
      { kind: "screen", id: "scr_pd9uqn" },
      { kind: "screen", id: "scr_zhfffe" },
      { kind: "screen", id: "scr_8djzwg" },
    ] },
    { kind: "section", id: "sec_ragkln", children: [
      { kind: "screen", id: "scr_jgq2zv" },
      { kind: "screen", id: "scr_viktor1" },
    ] },
    { kind: "section", id: "sec_9lgnx9", children: [
      { kind: "screen", id: "scr_eldpu2" },
      { kind: "screen", id: "scr_b6vq1n" },
    ] },
    { kind: "section", id: "sec_lolr7p", children: [
      { kind: "screen", id: "scr_mhpjmw" },
    ] },
    { kind: "section", id: "sec_9e3vw3", children: [
      { kind: "screen", id: "scr_jby7lc" },
    ] },
    { kind: "section", id: "sec_9jtu3w", children: [
      { kind: "screen", id: "scr_f9mdlt" },
    ] },
    { kind: "section", id: "sec_o8b4eg", children: [
      { kind: "screen", id: "scr_qsqbrh" },
      { kind: "screen", id: "scr_c83mze" },
      { kind: "screen", id: "scr_w8rlgg" },
      { kind: "screen", id: "scr_8qdbke" },
    ] },
    { kind: "section", id: "sec_qxv0p6", children: [
      { kind: "screen", id: "scr_51jglr" },
    ] },
    { kind: "section", id: "sec_qndaa4", children: [
      { kind: "screen", id: "scr_oabucw" },
      { kind: "screen", id: "scr_r395xl" },
      { kind: "screen", id: "scr_o13rzo" },
      { kind: "screen", id: "scr_ql2qkx" },
    ] },
  ],
}
